import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {CreateAlarmCenterZone} from 'src/services/api/endpoints/AlarmCenterEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useCreateAlarmCenterZone() {
  const {enqueueSnackbar} = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [QueryKeyEnum.CREATE_ALARM_CENTER_ZONE],
    mutationFn: async (body: CreateAlarmCenterZone) => {
      return (await api.alarmCenter.createZone(body)).data.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QueryKeyEnum.ALARM_CENTER_ZONES]})
      enqueueSnackbar('Zona cadastrada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos cadastrar a zona no momento')
    },
  })
}
